import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../elements/Loader'
import EmptyState from '../../elements/EmptyState'
// import ArrowUpTrayIcon from '../../elements/icons/ArrowUpTrayIcon'
// import AssessmentsFilters from '../../elements/filters/AssessmentsFilters'
import StudentSubjectCard from '../../elements/StudentSubjectCard'
import { fetchAssessments } from '../../../store/actions/assessmentsActions'
import Assessment from './Assessment'
import { authHeader, baseUrl } from '../../../utils';
import axios from 'axios';
import ChevronIcon from '../../elements/icons/ChevronIcon';
import StudentResult from './StudentResult';
import ModalDialog from '../../layouts/ModalDialog'
import ArrowIcon from '../../elements/icons/ArrowIcon';
import moment from 'moment';

const StudentAcademics = ({student}) => {
  const dispatch = useDispatch()
  const subjectsSelector = useSelector(state => state.subjects)
  const assessmentsSelector = useSelector(state => state.assessments)
  const [loadingResults, setLoadingResults] = React.useState(true)
  const [studentResults, setStudentResults] = React.useState([])
  useEffect(() => {
    const fetchStudentSubjects = async () => {
      try{
        const headers = authHeader()
        await axios.get(`${baseUrl}/students/${student._id}/current-subjects`, {headers})
        .then((response)=>{
          dispatch({
            type: 'GET_SUBJECTS',
            payload: response.data.data
          })
        })
      }catch(error) {
        console.error(error)
      }
    }

    const fetchStudentResults = async () => {
      try{
        const headers = authHeader()
        setLoadingResults(true)
        await axios.get(`${baseUrl}/student-results/student/${student._id}?expand=academicSession,class,term`, {headers})
        .then((response)=>{
          setStudentResults(response.data.data.results)
        })
      }catch(error) {
        console.error(error)
        dispatch({
          type: 'ERROR',
          error
        })
      } finally {
        setLoadingResults(false)

      }
    }

    fetchStudentSubjects()
    fetchStudentResults()
    dispatch(fetchAssessments(``, 0, 0))
    return () => {
      
    }

  }, [dispatch, student._id])

  // const [pagination, setPagination] = useState({
  //   page: 1,
  //   perPage: 25
  // })

  // const [assessmentFilters, setAssessmentFilters] = useState(`student=${student._id}`)
  // const assessmentsSelector = useSelector(state => state.assessments)

  
  const [sectionsHidden, setSectionsHidden] = React.useState({
    subjects: false,
    assessments: false,
    results: false
  })

  const [activeResult, setActiveResult] = React.useState(null)
  const [resultOpen, setResultOpen] = React.useState(false)

  const openResult = (result) => {
    setActiveResult(result)
    setTimeout(() => {
      setResultOpen(true)
    }, 200)
  }

  const closeResult = () => {
    setResultOpen(false)
    setTimeout(() => {
      setActiveResult(null)
    }, 200)
  }

  function isLessThanOneWeekPast(targetDate) {
    const oneWeekAgo = moment().subtract(7, 'days');
    const now = moment();
    
    // Returns true only if targetDate is between 1 week ago and right now
    return moment(targetDate).isAfter(oneWeekAgo) && moment(targetDate).isBefore(now);
  }

  return (
    <>
      <div className="w-full">
        <div className='pb-3 mb-2'>
          <div className="w-full mx-auto">
            <div className='w-full flex items-center justify-between'>
              <div className='w-full xl:w-2/3'>
                <h4 className='font-medium text-lg text-gray-600'>Student Academic Records</h4>
                <p className='text-gray-600 text-sm'>
                  All academic records for this student are displayed below.
                </p>
              </div>
              {/* <button onClick={()=>{setAddingFeedback(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                Add feedback for this student
              </button> */}
            </div>
          </div>
        </div>

        <div className='w-full border-b border-gray-300 pt-[20px] pb-[20px]'>
          <div className='w-full xl:flex items-start justify-between gap-x-4'>
            <div>
              <h4 className='font-medium text-gray-700'>Current Subjects</h4>
              <p className='text-sm text-gray-600'>These are all the subjects currently being studied by {student.fullName}</p>
            </div>
            <div className='flex flex-row-reverse mt-2 xl:mt-0'>
                <button onClick={() => setSectionsHidden({...sectionsHidden, subjects: !sectionsHidden.subjects})} className={`font-space-grotesk font-[600] text-xs  text-gray-600 p-3.5 rounded-full transition duration-200 hover:bg-gray-200/70 flex items-center justify-center gap-x-[5px] ${sectionsHidden.subjects ? 'bg-gray-100' : 'bg-transparent'}`}>
                    {sectionsHidden.subjects ? 'Show Subjects' : 'Hide Subjects'}
                    <ChevronIcon className={`w-4 h-4 transition ${sectionsHidden.subjects ? 'rotate-180' : 'rotate-[270deg]'} duration-200`} />
                </button>
              </div>
          </div>
          {!sectionsHidden.subjects && <>
            {subjectsSelector.loadingSubjects ? 
                <Loader /> 
              :
                subjectsSelector?.subjects?.subjects?.length > 0 ? 
                  <div className='w-full px-4 mt-[20px] grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-1'>
                    {subjectsSelector.subjects.subjects.map((subject, subjectIndex)=>(
                      <StudentSubjectCard 
                        key={subjectIndex} 
                        subject={subject} 
                        student={student} 
                      />))}
                  </div>
                :
                  <div className='mt-[50px]'>
                    <EmptyState emptyStateText={`This student has not been assigned any subjects yet.`} />
                  </div>
              }
          </>}
        </div>

        <div className='w-full pt-[20px] pb-[20px] border-b border-gray-300'>
            <div className='xl:flex items-start justify-between'>
              <div className='w-full xl:w-2/3'>
                <h4 className='font-medium mb-1 text-gray-700'>Assessments</h4>
                <p className='text-sm text-gray-600'>Assessment records for {student.fullName}.</p>
              </div>
              <div className='flex flex-row-reverse  mt-2 xl:mt-0'>
                <button onClick={() => setSectionsHidden({...sectionsHidden, assessments: !sectionsHidden.assessments})} className={`font-space-grotesk font-[600] text-xs  text-gray-600 p-3.5 rounded-full transition duration-200 hover:bg-gray-200/75 flex items-center justify-center gap-x-[5px] ${sectionsHidden.assessments ? 'bg-gray-100' : 'bg-transparent'}`}>
                    {sectionsHidden.assessments ? 'Show Records' : 'Hide Records'}
                    <ChevronIcon className={`w-4 h-4 transition ${sectionsHidden.assessments ? 'rotate-180' : 'rotate-[270deg]'} duration-200`} />
                </button>
              </div>
            </div>

            {!sectionsHidden.assessments && <div className='w-full mt-5 px-4'>
              {assessmentsSelector?.loadingAssessments ? 
                <Loader />
              :
                <>
                  {assessmentsSelector?.assessments?.assessments?.length === 0 ? 
                    <div className='w-full'>
                      <EmptyState emptyStateText={`No assessments created yet.`} />
                    </div>
                  :
                  <>
                    {assessmentsSelector?.assessments?.assessments?.map((assessment, assessmentIndex) => (
                      <div key={assessmentIndex} className='w-full mb-[10px]'>
                        <Assessment assessment={assessment} student={student} />
                      </div>
                    ))}
                  </>}
                </>
              }
            </div>}
        </div>

        <div id="student-results" className='w-full pt-[20px] pb-[20px]'>
          <div className='xl:flex items-start justify-between mb-[20px]'>
            <div className='w-full xl:w-2/3'>
              <h4 className='font-medium mb-1 text-gray-700'>Term Results</h4>
              <p className='text-sm text-gray-600'>Term results for {student.fullName}. Click on a result to see details and/or download</p>
            </div>
            <div className='flex flex-row-reverse  mt-2 xl:mt-0'>
              <button onClick={() => setSectionsHidden({...sectionsHidden, results: !sectionsHidden.results})} className={`font-space-grotesk font-[600] text-xs  text-gray-600 p-3.5 rounded-full transition duration-200 hover:bg-gray-200/70 flex items-center justify-center gap-x-[5px] ${sectionsHidden.results ? 'bg-gray-100' : 'bg-transparent'}`}>
                  {sectionsHidden.results ? 'Show Results' : 'Hide Results'}
                  <ChevronIcon className={`w-4 h-4 transition ${sectionsHidden.results ? 'rotate-180' : 'rotate-[270deg]'} duration-200`} />
              </button>
            </div>
          </div>

          {!sectionsHidden.results && <>
            {loadingResults ? 
                <Loader /> 
              :
                studentResults?.length > 0 ? 
                  <div className='w-full px-4 mt-[20px]'>
                    {studentResults.map((result, resultIndex)=>(
                      <div key={resultIndex} className={`p-4 border rounded-lg w-full lg:flex items-start justify-between gap-x-2 relative grid grid-cols-2 lg:grid-cols-6 gap-2 ${isLessThanOneWeekPast(result.createdAt) ? 'border-vcm-purple' : 'border-gray-200'}`}>

                        {isLessThanOneWeekPast(result.createdAt) && <span className="absolute -top-4 right-4 py-1.5 px-2.5 bg-vcm-purple inline-block rounded-full text-[11px] text-white" title="Uploaded recently font-bold">Uploaded recently</span>}

                        <div className="w-full col-span-2">
                          <p className="text-[11px] text-gray-500 mb-1">Term/Session</p>
                          <h3 className="text-xs text-gray-800 font-semibold">{result.term.name}</h3>
                          <p className="text-sm text-gray-600">{result.academicSession.name} Session</p>
                        </div>
                        <div className="w-full col-span-1">
                          <p className="text-[11px] text-gray-500 mb-1">Student Class</p>
                          <p className="text-sm text-gray-600">{result.class.name}</p>
                        </div>
                        <div className="w-full col-span-1">
                          <p className="text-[11px] text-gray-500 mb-1">Total Subjects</p>
                          <p className="text-sm text-gray-600">{result.subjectBreakdown.length}</p>
                        </div>
                        <div className="w-full col-span-1">
                          <p className="text-[11px] text-gray-500 mb-1">Total Passed</p>
                          <p className="text-sm text-gray-600">{result.subjectBreakdown.filter(subject => subject.passingGrade).length || 0}</p>
                        </div>
                        <div className="w-full col-span-1">
                          <p className="text-[11px] text-gray-500 mb-1">Student Average</p>
                          <p className="text-sm text-gray-600">{result.assessmentScores.termAverage.toFixed(2)}%</p>
                        </div>

                        <button onClick={()=>{openResult(result)}} className="absolute bottom-2 right-4 text-xs font-space-grotesk text-vcm-purple flex items-center gap-x-2 transition duration-200 hover:text-purple-400 font-semibold justify-center">
                          View Result
                          <ArrowIcon className="w-4 h-4" />
                        </button>
                      </div>
                    ))}
                  </div>
                :
                  <div className='mt-[50px]'>
                    <EmptyState emptyStateText={`This student has not received any results yet.`} />
                  </div>
              }
          </>}
        </div>
      </div>

      {activeResult !== null && (
        <ModalDialog
          shown={resultOpen} 
          closeFunction={()=>{closeResult()}} 
          actionFunction={()=>{}} 
          actionFunctionLabel={``}
          maxWidthClass='max-w-6xl'
          hideActions={true}
        >
          <StudentResult 
            student={student} 
            resultId={activeResult?._id} 
            close={()=>{closeResult()}} 
          /> 
        </ModalDialog>
        )}
    </>
  )
}

export default StudentAcademics